import { render, staticRenderFns } from "./TLoading.vue?vue&type=template&id=4b304105&scoped=true"
import script from "./TLoading.vue?vue&type=script&lang=js"
export * from "./TLoading.vue?vue&type=script&lang=js"
import style0 from "./TLoading.vue?vue&type=style&index=0&id=4b304105&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b304105",
  null
  
)

export default component.exports